module.exports = __webpack_public_path__ + "static/media/letter.7290f84d.svg";